module.exports = __webpack_public_path__ + "img/shuzi_tushi.707b37a0.png";